<div class="row bg-light">

  <!-- ELIGIBILITY -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary">
            <h2 class="font-weight-normal">{{translationPrefix + '.eligibility.heading' | translate}}</h2>
          </div>
          <div [innerHTML]="translationPrefix + '.eligibility.content' | translate: summary.eligibility"
               class="col-12"></div>
        </div>
      </div>
      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('eligibility')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editEligibility' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- ELIGIBILITY ATTESTATION -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary"><h2
              class="font-weight-normal">{{translationPrefix + '.attestationOfEligibility.heading' | translate}}</h2>
          </div>
          <div
              [innerHTML]="translationPrefix + '.attestationOfEligibility.content' | translate: summary.attestationOfEligibility"
              class="col-12"></div>
        </div>
      </div>

      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('attestation_of_eligibility')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editAttestationOfEligibility' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- PLAN -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary"><h2
              class="font-weight-normal">{{translationPrefix + '.plan.heading' | translate}}</h2>
          </div>
          <div [innerHTML]="translationPrefix + '.plan.content' | translate: summary.plan"
               class="col-12"></div>
        </div>
      </div>

      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('plan_selection')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editPlan' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- APPLICANT -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary"><h2
              class="font-weight-normal mb-0">{{translationPrefix + '.applicantInfo.heading' | translate}}</h2>
          </div>
          <div class="col-12">
            <div *ngFor="let item of applicantInfoSubsections; let i=index" class="row pt-4">
              <div class="col-12"><h2
                  class="font-weight-normal">{{translationPrefix + '.applicantInfo.subsections.' + i + '.heading' | translate}}</h2>
              </div>
              <div
                  [innerHTML]="translationPrefix + '.applicantInfo.subsections.' + i + '.content' | translate: summary.applicantInfo[i]"
                  class="col-12"></div>
            </div>
            <div *ngIf="showGenderAndIdentityField" class="row pt-4">
              <div class="col-12"><h2
                class="font-weight-normal">{{translationPrefix + '.applicantInfo.identityFields.heading' | translate}}</h2>
              </div>
              <div
                [innerHTML]="translationPrefix + '.applicantInfo.identityFields.content' | translate: summary.applicantInfo[6]"
                class="col-12"></div>
            </div>
            <div *ngIf="showRelationshipToEnrolleeField" class="row pt-4">
              <div class="col-12"><h2
                class="font-weight-normal">{{translationPrefix + '.applicantInfo.relationshipFields.heading' | translate}}</h2>
              </div>
              <div
                [innerHTML]="translationPrefix + '.applicantInfo.relationshipFields.content' | translate: summary.applicantInfo[7]"
                class="col-12"></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('applicant_info')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editApplicantInfo' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- LANGUAGE -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 text-primary"><h2
          class="font-weight-normal">{{translationPrefix + '.lang.heading' | translate}}</h2>
      </div>
      <div [innerHTML]="translationPrefix + '.lang.content' | translate: summary"
           class="col-12"></div>
    </div>
  </div>

  <!-- MEDICARE -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary"><h2
              class="font-weight-normal mb-0">{{translationPrefix + '.medicare.heading' | translate}}</h2>
          </div>
          <div class="col-12">
            <div *ngFor="let item of medicareSubsections; let i=index" class="row pt-4">
              <div class="col-12"><h2
                  class="font-weight-normal">{{translationPrefix + '.medicare.subsections.' + i + '.heading' | translate}}</h2>
              </div>
              <div
                  [innerHTML]="translationPrefix + '.medicare.subsections.' + i + '.content' | translate: summary.medicareInfo[i]"
                  class="col-12"></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('medicare_info')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editMedicareInfo' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- PCP -->
  <div class="col-12 py-4 border-bottom">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary"><h2
              class="font-weight-normal">{{translationPrefix + '.pcp.heading' | translate}}</h2>
          </div>
          <div class="col-12">
            <div class="row pt-2">
              <div class="col-12"><h2
                  class="font-weight-normal">{{translationPrefix + '.pcp.subsections.0.heading' | translate}}</h2>
              </div>
              <div
                  [innerHTML]="translationPrefix + '.pcp.subsections.0.content' | translate: summary.pcp[0]"
                  class="col-12"></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('pcp')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editPCP' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- PAYMENT -->
  <div [ngClass]="{'border-bottom': showAgreement}" class="col-12 py-4">
    <div class="row">
      <div class="col-12 col-md-8">
        <div class="row">
          <div class="col-12 text-primary">
            <h2 class="font-weight-normal">{{translationPrefix + '.payment.heading' | translate}}</h2>
          </div>
          <div [innerHTML]="translationPrefix + '.payment.content' | translate: summary.payment"
               class="col-12"></div>
        </div>
      </div>
      <div *ngIf="showSectionNavigation" class="col-12 col-md-4 mt-3 mt-md-0">
        <button (click)="emitNavigationOccurred('payment')"
                class="btn btn-warning btn-lg btn-block"
                type="button">{{ translationPrefix + '.actions.editPayment' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- AGREEMENT -->
  <div *ngIf="showAgreement" class="col-12 py-4">
    <div class="row">
      <div class="col-12 text-primary"><h2
          class="font-weight-normal">{{translationPrefix + '.agreement.heading' | translate}}</h2>
      </div>
      <div class="col-12">
        <div *ngFor="let item of agreementSubSections; let i=index" class="row pt-4">
          <div class="col-12"><h2
              class="font-weight-normal">{{translationPrefix + '.agreement.subsections.' + i + '.heading' | translate}}</h2>
          </div>
          <div
              [innerHTML]="translationPrefix + '.agreement.subsections.' + i + '.content' | translate: summary.applicantInfo[i]"
              class="col-12"></div>
        </div>
      </div>
    </div>
  </div>
</div>
